import type { GroupWithMembers } from '@/api/groups';

/**
 * Who may edit or delete an expense. Mirrors the expenses_update/expenses_delete
 * RLS policies and the mobile src/utils/expense-permissions.ts: the creator, the
 * payer, or a group admin when the group allows admins to edit all expenses
 * (groups.admins_can_edit_expenses, DB default true).
 */
export function canModifyExpense(
  expense: { created_by?: string | null; paid_by?: string | null },
  userId: string | undefined,
  group: GroupWithMembers | null | undefined
): boolean {
  if (!userId) return false;
  if (expense.created_by === userId || expense.paid_by === userId) return true;
  const isGroupAdmin = !!group?.members.some(m => m.user_id === userId && m.role === 'admin');
  return isGroupAdmin && (group?.admins_can_edit_expenses ?? true);
}
